<template>
	<div>
		<DoorsaleHeader :current-step="currentStep" :event-id="eventId" />

		<BaseContainer>
			<!-- Page header: back button + title + optional sub-header content -->
			<div class="md:mt-10 mb-2 md:mb-10 flex flex-col-reverse md:flex-row md:gap-10 justify-between md:items-end">
				<div class="flex-1 md:max-w-2xl animate-appear">
					<BaseButton
						v-if="showBack"
						size="sm"
						color="default"
						class="flex gap-1 items-center text-xs text-text hover:underline cursor-pointer mt-3"
						@click="onBack ? onBack() : $router.back()"
					>
						<DropdownIcon class="w-3 h-3 fill-current rotate-90" />
						{{ $t('common.back') }}
					</BaseButton>
					<h1 class="h2 mt-2">{{ title }}</h1>
					<slot name="header" />
				</div>
				<div class="md:w-120 md:max-w-full flex -mx-4 md:mx-0 items-center justify-between">
					<slot name="header-actions" />
					<div
						v-if="cart.cartExpire > 0 && route.name !== 'doorsale-seats'"
						class="items-center gap-1 font-semibold text-sm hidden md:flex"
					>
						<StopwatchIcon class="fill-primary w-6 h-6" />
						<BaseCountdown :date="cart.cartExpire" /> {{ $t('checkout.countdown') }}
					</div>
				</div>
			</div>

			<!-- Two-column content -->
			<div class="flex flex-col md:flex-row gap-10 justify-between mb-4">
				<div class="flex-1 md:max-w-2xl min-w-0">
					<slot />
				</div>
				<div class="w-full md:w-120 md:max-w-1/2 min-w-0">
					<slot name="aside" />
				</div>
			</div>
		</BaseContainer>
	</div>
</template>

<script setup lang="ts">
	import { useRoute, useRouter } from 'vue-router';

	import DropdownIcon from '@/components/icons/DropdownIcon.vue';
	import StopwatchIcon from '@/components/icons/StopwatchIcon.vue';
	import BaseButton from '@/components/ui/BaseButton.vue';
	import BaseContainer from '@/components/ui/BaseContainer.vue';
	import BaseCountdown from '@/components/ui/BaseCountdown.vue';
	import { useCartStore } from '@/stores/cart';
	import { useDoorsaleGestureNav } from '@/utils/useDoorsaleGestureNav';

	import DoorsaleHeader from './DoorsaleHeader.vue';

	const route = useRoute();
	const router = useRouter();
	const cart = useCartStore();

	const props = withDefaults(defineProps<{
		title: string;
		currentStep: number;
		eventId?: number | string;
		showBack?: boolean;
		onBack?: () => void;
		onForward?: () => void;
	}>(), {
		showBack: true,
	});

	useDoorsaleGestureNav(
		props.onBack ? () => props.onBack!() : undefined,
		props.onForward ? () => props.onForward!() : undefined,
	);
</script>
